// extracted by mini-css-extract-plugin
export default {"link":"FinderLink_link__X+Dec"};